import {graphql, useStaticQuery} from 'gatsby'

import {DisallowedEmailsQuery} from '@/graphql-types'

/*
 * Regex explanation: ^([\w-+.]+@(?!gmail.com)([\w-]+\.)+[\w-]{2,8})?$
 * `^` starts with
 * `(` opens capturing group
 * `\w-+.` matches a 'word character'. That's from a-z, A-Z, 0-9, including the _ (underscore) character, and we add the special chars ".+-"
 * `+@` followed by
 * then we map `disallowedEmails` which is a list of TLDs coming from out CMS
 * `\w-.` matches a 'word character' and hyphen
 * `.` matches the dot of the domain extension
 * `[\\w-]{2,8}` matches domain extension between 2 and 8 chars
 * `)` closes capturing group
 * `?` matches the previous token between zero and one times,
 * `$` asserts position at the end of a line
 *
 * for more, paste the regex here https://www.debuggex.com/
 */

export const checkEmailAgainst = (disallowedEmails: string[]) => (email: string) => {
    const disallowedEmailsRegex = new RegExp(
        `^([\\w-+.]+@${disallowedEmails
            .map((email) => `(?!${email})`)
            .join('')}([\\w-]+\\.)+[\\w-]{2,8})?$`
    )

    return !!email && disallowedEmailsRegex.test(email)
}

export const useIsCompanyEmail = (email: string) => {
    const data: DisallowedEmailsQuery = useStaticQuery(graphql`
        query DisallowedEmails {
            allPrismicDisallowedEmails {
                nodes {
                    data {
                        emails {
                            email
                        }
                    }
                }
            }
        }
    `)

    const disallowedEmails = data.allPrismicDisallowedEmails.nodes[0].data.emails.map(
        ({email}) => email
    )
    const isCompanyEmail = checkEmailAgainst(disallowedEmails)

    return isCompanyEmail(email)
}
